import LeadBoosterPromoLead from 'interfaces/LeadSettings/LeadBoosterPromoLead'
import { ScheduledTermination } from 'interfaces/ScheduledTermination'
import { ProvidersPresenceSubscription } from './PresenceSubscription'

export const HAPPINESS_UNHAPPY = 1
export const HAPPINESS_NEUTRAL = 2
export const HAPPINESS_HAPPY = 3

export type Happiness = typeof HAPPINESS_UNHAPPY | typeof HAPPINESS_NEUTRAL | typeof HAPPINESS_HAPPY

type CategoryResults = {
    profile: Record<string, number>
    leads: Record<string, number>
    response: Record<string, number>
    contact: Record<string, number>
    invoices: Record<string, number>
    happiness: Happiness
}

export interface SatisfactionScore {
    profile_happiness: Happiness
    leads_happiness: Happiness
    response_happiness: Happiness
    contact_happiness: Happiness
    invoices_happiness: Happiness
    happiness: Happiness
    resultsObj?: CategoryResults
}

export type WebinarOnboardingStatus = 'Subscribed' | 'Attended' | 'No show'

export interface Provider {
    // not complete yet
    service_provider_id: number
    business_name: string
    profile_url: string
    providerUrl: string
    providerUrlVisible: boolean
    paytUrl?: string
    providers_dates: number[]
    nr_blocked_days: number
    isSigned: boolean
    isSignedOrFreeTrial: boolean
    isFreeTrial: boolean
    serviceLimitReached?: boolean
    softDailyLimitReached?: boolean
    softDailyLimitReachedServices?: string
    hubspot_contact_id: number | null
    isCancelSigningDate: string | null
    isUnsubscribed: string | null
    subscriptionStatus: string | null
    country_code: string
    free_leads: FreeLead[]
    hasActiveLeadBooster: boolean
    lead_booster_promo_leads: LeadBoosterPromoLead[]
    active_free_trial: { free_lead_id: number } | null
    presence_subscriptions?: ProvidersPresenceSubscription[]
    scheduledTermination?: ScheduledTermination | null
    user?: number
    lead_setting?: number
    franchise_status?: number
    /** Resolved from the franchise main, since that is the only row the setting lives on. */
    centralizedReviewCollection?: boolean
    /** Accounts in this provider's franchise, main included. 0 when it is not part of one. */
    nrFranchiseAccounts?: number
    payment_info_franchise?: boolean
    website?: string
    quality_scores?: any[]
    stats_start_date?: string
    is_franchise_main: boolean
    last_satisfaction_score: SatisfactionScore | null
    _isLoadingSatisfaction?: boolean
    notes?: []
    duplicateProfile?: number | null
    demandUserRequestId?: number | null
    webinar_onboarding_attendance_status: WebinarOnboardingStatus | null
}

export interface PauseReason {
    pause_reason_id: number
    country_code: string
    visible: boolean
    premium_only: boolean
    type: number
    reason: string
}

export interface ProvidersDate {
    provider_date_id: number | string
    service_provider_id: number
    created: string
    date_from: string
    date_to: string
    subscription_id: number | null
    admin_user_id: number | null
    pause_type: 0 | 1 | 2 | 3
    pause_deleted: string | null
    day_scheme: 0 | 1 | 2 | 3 | 4
    pause_reason_id: number | null
    _calculated?: ProvidersDateCalulated
}

interface ProvidersDateCalulated {
    from: Date
    to: Date
    isRepeated: boolean
    isActive: boolean
    isFuture: boolean
    isPast: boolean
}

export interface FreeLead {
    free_lead_id: number
    service_provider_id: number
    user_id: number | null
    comment: string
    nr_leads: number
    nr_leads_left: number
    created: string
    expiration: string | null
    active: boolean
    enable_after_nr_leads_payed: number | null
    free_lead_type: string | null
}
